
import gql from "graphql-tag";

export const logContactMutation = gql`
  mutation logContact(
    $supporterId: ID!,
    $groupId: ID!,
    $contactMethod: String!,
    $contactStatus: String!,
    $note: String,
    $tags: [String!],
    $eventId: ID,
  ) {
    logContact(
      input: {
        supporterId: $supporterId,
        groupId: $groupId,
        contactMethod: $contactMethod,
        contactStatus: $contactStatus,
        note: $note,
        tags: $tags,
        eventId: $eventId
      }
    ) {
      success
      errors {
        message
        code
      }
    }
  }
`